import { render, staticRenderFns } from "./ToyForm.vue?vue&type=template&id=24222acf"
import script from "./ToyForm.vue?vue&type=script&lang=js"
export * from "./ToyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports